import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: var(--space-3xl);
  text-align: center;
`;

const Blog = () => {
  return (
    <Container>
      <h1>Blog</h1>
      <p>Coming soon - Read about our RV adventures, tips, and travel stories!</p>
    </Container>
  );
};

export default Blog;
